import { useEffect } from "react";
import Lenis from "lenis";

// Initialise Lenis once at the app root.
// lerp ~0.1, smoothWheel true; drives Framer Motion scroll-based animations.
export function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            lerp: 0.1,
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.5,
        });

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
        // Mount-once effect: Lenis instance lives for the app's lifetime.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
